import React from "react";
import {useTable} from "react-table";
import {useSelector} from "react-redux";
import moment from "moment";

const DocumentsTable = ({documents}) => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });

  const columns = React.useMemo(() => [
    {
      Header: "Name",
      id: "name",
      accessor: (row) => row.name.toLowerCase(),
      Cell: ({cell: {row: {original}}}) => (
        <a href={original.asset_url} target="_blank">{original.name}</a>
      )
    }, {
      Header: "Created at",
      id: "created_at",
      accessor: (row) => moment(row.created_at).toDate(),
      Cell: ({cell: {row: {original: {created_at}}}}) => moment(created_at).format("lll")
    }
  ], [documents])

  const {getTableProps, headerGroups, rows, prepareRow} = useTable({
    columns,
    data: documents,
  });

  return (
    <table {...getTableProps()} className="table table-responsive">
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map(column => (
            <th key={column.id}>
              {column.render('Header')}
            </th>
          ))}
          <th/>
        </tr>
      ))}
      </thead>
      <tbody>
      {rows.map(
        (row, i) =>
          prepareRow(row) || (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
      )}
      </tbody>
    </table>
  )
}

export default DocumentsTable;
